/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A6Inputs */

const en_viewer_faq_a6 = /** @type {(inputs: Viewer_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every node is labelled with its type, so a null reads as null and an empty string reads as a string with no content. In raw text those two look similar enough to confuse while scanning, which is one of the main reasons to use the tree.`)
};

const ko_viewer_faq_a6 = /** @type {(inputs: Viewer_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 노드에 타입이 표시되므로 null은 null로 읽히고 빈 문자열은 내용이 없는 문자열로 읽힙니다. 원문 텍스트에서 이 둘은 훑는 동안 혼동할 만큼 비슷하게 보이며, 트리를 쓰는 주된 이유 중 하나입니다.`)
};

const ja_viewer_faq_a6 = /** @type {(inputs: Viewer_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのノードに型が表示されるので、null は null と読め、空文字列は内容のない文字列と読めます。生のテキストではこの 2 つは目を通す間に混同するほど似て見え、ツリーを使う主な理由の 1 つです。`)
};

/**
* | output |
* | --- |
* | "Every node is labelled with its type, so a null reads as null and an empty string reads as a string with no content. In raw text those two look similar enoug..." |
*
* @param {Viewer_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a6 = /** @type {((inputs?: Viewer_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a6(inputs)
	if (locale === "ko") return ko_viewer_faq_a6(inputs)
	return ja_viewer_faq_a6(inputs)
});